export const STORE_VERSION = 37; // Must increment anytime schema is changed.
